
    'use strict';

    import { Component, Inject, Input} from 'ng-metadata/core';
	import {FacetService} from '../../facet/facet.service';
	import {SearchService} from '../../search.service';
    import {PnxUtil} from '../../../nddUtils/pnxUtil.service';
    import {ResultUtil} from '../../../nddUtils/resultUtil.service';
    import {PrimolyticsService,beacon} from '../../../analytics/primolytics.service';
    import {SearchFieldsService} from '../../search.fields.service';
    import {ConfigurationUtil} from  '../../../nddUtils/configurationUtil.service';
    import {AnalyticsUtils} from "../../../nddUtils/analyticsUtils.service";

    const flatten = require('lodash/flatten');
    const he= require('he');
    const _escape = require('lodash/escape');
    const _get= require('lodash/get');

    @Component({
        selector: 'prm-search-result-frbr-line',
        templateUrl: 'components/search/searchResult/searchResultFrbr/searchResultFrbrLine.html'
    })


   export  class PrmSearchResultFrbrLine {

        @Input() isFullView: boolean;
        @Input() result;
        @Input() index;

        constructor(private searchService: SearchService,
                    private facetService: FacetService,
                    private searchFieldsService: SearchFieldsService,
                    private configurationUtil:ConfigurationUtil,
                    private pnxUtil : PnxUtil,
                    private resultUtil: ResultUtil,
                    @Inject('searchResultsIcons') private searchResultsIcons,
                    private primolyticsService: PrimolyticsService,
                    @Inject('$stateParams') private $stateParams: ng.ui.IStateParamsService,
                    @Inject('$stateParams') private $state: ng.ui.IStateService,
                    @Inject('$mdDialog') private $mdDialog: angular.material.IDialogService,
                    private analyticsUtils: AnalyticsUtils,) {
        }

        @beacon({'p':'refine', 'op':'frbr','item':'result'})
        getFrbrRecords(){
            let facetString= 'frbrgroupid' + ','+'include'+','+this.pnxUtil.getValue(this.result, 'facets', 'frbrgroupid');
            let recTitle = this.pnxUtil.getValue(this.result, 'display', 'title');
            this.facetService.frbrSearch({facet: facetString, title: recTitle}, this.index);
            this.sendAnalytics();
            this.$mdDialog.hide(); //this is done in order to close the full view dialog in case the frbr is selected from it
        }

        getPlaceHolders() {
            let val = this.pnxUtil.getValue(this.result, 'display', 'version');
            return {idx_0: val};
        }

        getTitle() {
            let recTitle = this.pnxUtil.getValue(this.result, 'display', 'title');
            return recTitle;
        }

        isPc(){
            return this.result.context === 'PC';
        }

         isFrbrGeneric(){
            return this.resultUtil.isFrbr(this.result) && this.searchService.getFrbrDisplay() === 1 ;  //Generic Record
        }

        public escapeString(str) {
            return _escape(str)
        }

        /**
         * saved to session storage when:
         * 1. yourSelectedRecordItem feature is active in BO
         * 2. the frbr record is of type preffered (not generic)
         */
        private handleYourSelectedRecordItem() {
            //save clicked item on session storage for further use of yourSelectedRecord feature
            if (this.searchService.isHighlightTheRecordYouCameFromEnabled() && !this.isFrbrGeneric()) {
                sessionStorage.setItem(this.searchService.YOUR_SELECTED_RECORD_ITEM, JSON.stringify(this.result));
            }
        }
        private sendAnalytics(){
            let payload = this.getAnalyticsPayload();
            this.analyticsUtils.trackUsage(this.analyticsUtils.eventsNames.FRBR_LINK, payload);
        }
        private getAnalyticsPayload() {
            return {
                'Versions Count': _get(this.result, 'pnx.display.version[0]'),
                "Record Title": _get(this.result, 'pnx.display.title[0]'),
                'Resource Type': _get(this.result, 'pnx.display.type[0]'),
                "Record ID": _get(this.result, 'pnx.control.recordid[0]')
            }
        }
    }



// WEBPACK FOOTER //
// ./src/main/webapp/components/search/searchResult/searchResultFrbr/searchResultFrbrLine.directive.ts